<template>
  <v-dialog
    v-model="showSetting"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title>
        Settings
        <v-spacer />
        <v-btn
          icon
          @click="close()"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-container class="px-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="settingInfo.quantityAlignment"
                clearable
                label="Quantity Placement"
                :items="alignments"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          @click="close()"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          @click="updateSetting()"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "KotSettings",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      settingInfo: {
        quantityAlignment: "RIGHT"
      },
      alignments: [
        { id: "RIGHT", label: "Right" },
        { id: "LEFT", label: "Left" }
      ]
    };
  },
  computed: {
    showSetting() {
      return this.show;
    }
  },
  watch: {
    show: {
      handler(v) {
        if (v) {
          this.settingInfo = this.settings;
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },

    updateSetting() {
      this.$emit("update", this.settingInfo);
      this.close();
    }
  }
};
</script>